import styled, { css } from "styled-components";
import { deviceMax } from "../../../utils/device";

export const CardWrapper = styled.article(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.brand.line};
    border-radius: ${theme.layout.radius.card};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;

    &::before {
      background: ${theme.gradients.brand};
      content: "";
      height: 3px;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  `
);

export const CardBody = styled.div`
  flex: 1;
  padding: 31px 32px 30px;

  @media ${deviceMax.desktopSMax} {
    padding: 28px;
  }

  @media ${deviceMax.phoneMax} {
    padding: 26px;
  }
`;

export const CardTopline = styled.div`
  align-items: center;
  display: flex;
  gap: 14px;
  justify-content: space-between;
  margin-bottom: 20px;

  @media ${deviceMax.tabletWideMax} {
    flex-wrap: wrap;
    gap: 9px;
    margin-bottom: 16px;
  }
`;

export const CardName = styled.h3(
  ({ theme }) => css`
    font-family: ${theme.typography.fonts.display};
    font-size: 20px;
    font-weight: 650;
    letter-spacing: -0.035em;
    line-height: 1.2;
    margin: 0;

    @media ${deviceMax.phoneMax} {
      font-size: 18px;
    }
  `
);

/** The testimonial quote - the card's focal content, so it keeps the
 * design's large display-heading slot rather than plain body copy. */
export const CardQuote = styled.h4(
  ({ theme }) => css`
    font-family: ${theme.typography.fonts.body};
    font-size: 15px;
    font-style: italic;
    font-weight: 400;
    line-height: 1.6;
    margin: 0 0 18px;
    max-width: 465px;
  `
);

export const CardRole = styled.p`
  color: ${({ theme }) => theme.colors.brand.muted};
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  max-width: 465px;

  @media ${deviceMax.tabletWideMax} {
    font-size: 13px;
  }
`;

export const CardFoot = styled.div(
  ({ theme }) => css`
    align-items: center;
    background: ${theme.colors.brand.soft};
    color: #52647a;
    display: flex;
    font-size: 11px;
    font-weight: 600;
    gap: 9px;
    padding: 16px 32px;
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover {
      color: ${theme.colors.brand.deep};
    }

    svg {
      height: 17px;
      width: 17px;
    }

    @media ${deviceMax.phoneMax} {
      padding: 16px 26px;
    }
  `
);
